import { Tabs } from 'antd';
import React, { useState } from 'react'
import Awards from './Awards';
import LoyailyPrograms from './LoyaltyPrograms';
import General from './General';
const { TabPane } = Tabs;

const Affiliation = (props: any) => {
  const [disabledFlag, setDisabledFlag] = useState<any>(false)

  const disableTabPanes = (value: Boolean) => {
    setDisabledFlag(value)
  }
  return (
      <Tabs defaultActiveKey="0">
        <TabPane tab="General" key="0" disabled={disabledFlag}>
          <General />
        </TabPane>
        <TabPane tab="Awards/Ratings" key="1" disabled={disabledFlag}>
          <Awards isEditable={props.isEditable} cancelEditable={props.cancelEditable} disableTabPanes={disableTabPanes} />
        </TabPane>
        <TabPane tab="Loyalty Programs" key="2" disabled={disabledFlag}>
          <LoyailyPrograms isEditable={props.isEditable} cancelEditable={props.cancelEditable} disableTabPanes={disableTabPanes} />
        </TabPane>
      </Tabs>
  )
}

export default Affiliation;
